import { QuoteLocationSurcharge } from "./quote-location-surcharge.type";
import { containerLoad } from "../../shared/container/load-types.const";
import { FclQuoteLocationSurcharge } from "./models/quote-location-surcharge-fcl.model";
import { LclQuoteLocationSurcharge } from "./models/quote-location-surcharge-lcl.model";
import { ContainerPrices } from "../../shared/container/container-prices.model";
import { AirQuoteLocationSurcharge } from "./models/quote-location-surcharge-air.model";
import { QuoteMapper } from "../models/quote.mapper";
export class QuoteLocationSurchargeMapper {
  public static map(data: any): QuoteLocationSurcharge {
    if (!data) {
      return null;
    }

    if (!data.discriminator) {
      console.error("no discriminator");

      return null;
    }

    if (data.discriminator === containerLoad.fcl) {
      return new FclQuoteLocationSurcharge(
        data.id,
        data.discriminator,
        data.name,
        data.internalNote,
        new ContainerPrices(data.containers),
        parseFloat(data.shipmentPrice) || 0,
        QuoteMapper.map(data.quote),
        data.shipmentDisplayUnitName,
      );
    }

    if (data.discriminator === containerLoad.lcl) {
      return new LclQuoteLocationSurcharge(
        data.id,
        data.discriminator,
        data.name,
        data.internalNote,
        parseFloat(data.weightPrice) || 0,
        parseFloat(data.measurementPrice) || 0,
        parseFloat(data.shipmentPrice) || 0,
        parseFloat(data.piecePrice) || 0,
        parseFloat(data.documentPrice) || 0,
        QuoteMapper.map(data.quote),
      );
    }

    if (data.discriminator === containerLoad.air) {
      return new AirQuoteLocationSurcharge(
        data.id,
        data.discriminator,
        data.name,
        data.internalNote,
        parseFloat(data.weightPrice) || 0,
        parseFloat(data.chargeableWeightPrice) || 0,
        parseFloat(data.measurementPrice) || 0,
        parseFloat(data.shipmentPrice) || 0,
        parseFloat(data.piecePrice) || 0,
        parseFloat(data.documentPrice) || 0,
        QuoteMapper.map(data.quote),
      );
    }
  }
}
